/**
 * Portal ICAVI - Serviço de domínio: Empresas
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import axios from 'axios';
import { api } from '../apiClient';
export const empresasServiceMethods = {
    /**
     * Busca lista de empresas (normaliza variações de status na resposta)
     */
    async getEmpresas() {
        try {
            const response = await api.get('/api/empresas/list');
            // Normaliza variações de status ('success' vs 'sucesso')
            if (response.data &&
                (response.data.status === 'success' || response.data.status === 'sucesso')) {
                return {
                    status: 'sucesso',
                    empresas: response.data.empresas || [],
                };
            }
            return response.data || response;
        }
        catch (error) {
            console.error('Erro ao buscar empresas:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
};
